import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute, ResolveEnd, NavigationEnd, RouterEvent } from "@angular/router";
import { delay, filter, Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class AdminGuard  {
  token: any;
  constructor(public router: Router, public route: ActivatedRoute) {
    
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not    
    
      let user = JSON.parse(localStorage.getItem("currentUser"));
      if (!user || user === null) {
        this.router.navigate(["/auth/login"]);
        return true;
      } else if (user) {
        if (!Object.keys(user).length) {
          this.router.navigate(["/auth/login"]);
          return true;
        }
      }
      return true;
  }
}
